export const TRIAL_SESSION_ENDED_MESSAGE = 'Trial session has ended';

export class TrialSessionEndedError extends Error {
  readonly status = 402;

  constructor(message = TRIAL_SESSION_ENDED_MESSAGE) {
    super(message);
    this.name = 'TrialSessionEndedError';
  }
}

export const isTrialSessionEndedError = (
  error: unknown
): error is TrialSessionEndedError | { status: 402; message?: string } =>
  error instanceof TrialSessionEndedError ||
  (typeof error === 'object' &&
    error != null &&
    'status' in error &&
    (error as { status?: number }).status === 402 &&
    (!('message' in error) ||
      !(error as { message?: string }).message ||
      (error as { message?: string }).message === TRIAL_SESSION_ENDED_MESSAGE));

export class TrialUpgradeRequestError extends Error {
  readonly code?: string;

  readonly status?: number;

  constructor({
    code,
    message,
    status,
  }: {
    code?: string;
    message?: string;
    status?: number;
  } = {}) {
    super(message || 'Upgrade request failed');
    this.name = 'TrialUpgradeRequestError';
    this.code = code;
    this.status = status;
  }
}
